import { useCallback } from "react";

import { useAppDispatch } from "~/hooks/reduxHooks";
import { startTour } from "~/store/walkthroughSlice";

const useStartTour = (): ((tourId: string, conceptId?: string, dismissible?: boolean) => void) => {
	const dispatch = useAppDispatch();
	return useCallback((tourId: string, conceptId?: string, dismissible?: boolean) => {
		dispatch(startTour({ conceptId, tourId, dismissible }));
	}, []);
};

export default useStartTour;
